import { Button, Form } from 'antd';
import React, { FC, useState } from 'react';
import OWUpload from '../../OWUpload';
import { nullSafeGetOrElse } from '../../../utils/DataAccessUtils';
import { getDefaultFileListFromString } from '../../../utils/FileAccessUtils';
import { withUserType } from '../../withUserType';

export const validAttachment = (attachment) =>
	nullSafeGetOrElse('fileIdWithName', attachment, '').split('/').length === 2;

export const UPLOAD_TYPES = {
	IMAGE: 'image',
	PDF: 'pdf',
	VIDEO: 'video',
	EMBEDDED_VIDEO: 'embeddedVideo',
};

const TroubleshootingStepAttachmentField: FC<any> = ({
	step,
	setAttachments,
	userType,
}): React.ReactElement => {
	const existingAttachments = nullSafeGetOrElse('attachments', step, []).map(
		(_) => _.fileIdWithName
	);

	const [fileList, setFileList] = useState(getDefaultFileListFromString(existingAttachments));

	const handleChange = ({ fileList: newFileList }) => {
		setFileList(newFileList);

		const transformed = newFileList
			.filter((file) => file.status === 'done')
			.map((file) => {
				const fileId = nullSafeGetOrElse('response.data.fileId', file, file.uid);
				const fileName = nullSafeGetOrElse('response.data.fileName', file, file.name);

				return {
					fileIdWithName: `${fileId}/${fileName}`,
					attachmentType: fileName.toLowerCase().endsWith('.pdf') ? 'pdf' : 'image',
				};
			});

		setAttachments(transformed);
	};

	return (
		<>
			<Form.Item name="fileList" style={{ marginBottom: '8px' }}>
				<OWUpload
					accept={'image/*,.pdf'}
					roleType={userType}
					listType="picture-card"
					fileList={fileList}
					onChange={handleChange}
				>
					<Button type="link">Attach files</Button>
				</OWUpload>
			</Form.Item>
		</>
	);
};

export default withUserType(TroubleshootingStepAttachmentField);
